export default "__VITE_ASSET__CklMWBCk__"